module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/142-tibet-0f7c77925a583de428d281fefe919d30.svg";